export const introduce = {
  text: `### 使用方法
  + 注意上升及下降趋势的转换，以判断市场情绪的倾向。

  ### 指标原理
  + 该指标在持有年龄分布基础上进一步计算得出。统计了至少1年没有发生转移的比特币数量占总供应量的百分比。该指标是一个利用链上数据识别不同地址之间发生coin转移时间的很好例证。
  
  ### 创作者
  + 持有年龄的概念由 [Unchained Capital](https://unchained.com/) 开发
  + 该指标由 Philip Swift 发明
  `,
  height: 1400,
};
